import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addMasterPayment = createAsyncThunk('addMasterPayment', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'payment',
            data: {
                "role_id": String(data?.values?.roleId),
                "recurring_payment": Number(data?.values?.recurringPayment),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
